import {BehaviorSubject} from 'rxjs';

export const riskLimits$ = new BehaviorSubject([]);
export const riskLimitCache$ = new BehaviorSubject(new Map());
